export default __webpack_public_path__ + "static/media/remo3.639111ff.jpg";